import axios from "axios";
import { PURCHASE_RECEIVE_URL, PR_MAIL_INVOICE, PRODUCTS_URL, CUSTOMERS_URL, PURCHASE_RECEIVE_V2_URL } from "../../../../../constants/config";
import { initialFilter } from "../../pages/purchase-receives-list/PurchaseReceivesListUIHelpers";
import { REPLACE_TO_DEFAULT_QUERY_PARAMS } from "../../../Common/utils";

export function findProducts(queryParams) {
  return axios.get(
    `${PRODUCTS_URL}/list3?supplier_ids=${queryParams.supplier_id}&qry_param=${queryParams.searchKey}&page=${queryParams.pageNumber}&page_size=${queryParams.pageSize}&sort_by=name&sort_in=asc&brand_ids=`
  );
}

export function sendEmail(email) {
  return axios.post(`${PR_MAIL_INVOICE}`, email);
}

export function getPurchaseReceive(queryParams) {
  queryParams = queryParams === undefined ? initialFilter : REPLACE_TO_DEFAULT_QUERY_PARAMS(queryParams, initialFilter);
  return axios.get(
    `${PURCHASE_RECEIVE_V2_URL}/list?search_key=${queryParams.searchKey ? queryParams.searchKey : ""}&page=${queryParams.pageNumber}&page_size=${queryParams.pageSize}&supplier_ids=${queryParams.supplier_ids ? queryParams.supplier_ids : []}&channel_ids=${queryParams.channel_ids ? queryParams.channel_ids : []}&purchase_order_no=${queryParams.purchase_order_no ? queryParams.purchase_order_no : ""}&purchase_receive_no=${queryParams.purchase_receive_no ? queryParams.purchase_receive_no : ""}&receiving_date=${queryParams.receiving_date ? queryParams.receiving_date : ""}&sort_by=${queryParams.sortField}:${queryParams.sortOrder}`
  );
}

export function voidPurchaseReceive({ id, status }) {
  return axios.patch(`${PURCHASE_RECEIVE_V2_URL}/${id}`, {
    status: parseInt(status),
  });
}

export function getPurchaseReceiveById(id) {
  return axios.get(`${PURCHASE_RECEIVE_V2_URL}/${id}`);
}

export function addPayment(payment) {
  return axios.post(`${PURCHASE_RECEIVE_URL}/pay`, payment);
}

export function rejectReceipt(rejectedReceipt) {
  let receiveId = rejectedReceipt.receiveId;
  delete rejectedReceipt.receiveId;
  return axios.patch(`${PURCHASE_RECEIVE_URL}/${receiveId}`, rejectedReceipt);
}

export function createPurchaseReceiveOrder(receivedOrder) {
  return axios.post(`${PURCHASE_RECEIVE_V2_URL}`, receivedOrder);
}

export function editPurchaseReceive(orderReceive, id) {
  return axios.put(`${PURCHASE_RECEIVE_V2_URL}/${id}`, orderReceive);
}

export function findSuppliers(queryParams) {
  return axios.get(`${CUSTOMERS_URL}/list?qry_param=${queryParams.searchKey}&page=${queryParams.pageNumber}&page_size=${queryParams.pageSize}`);
}

export function searchSuppliers(queryParams) {
  return axios.get(`${CUSTOMERS_URL}/list2?qry_param=${queryParams}`);
}

export function changeReceiveStatus(queryParams) {
  return axios.patch(`${PURCHASE_RECEIVE_URL}/${queryParams.order.id}`, {
    status: parseInt(queryParams.status),
  });
}

export function updateProductPrices(products) {
  return axios.post(`${PRODUCTS_URL}/update-prices`, products);
}
